             
<template>
  <div class="set-accuracy d-flex justify-content-end">
    <div class="mt-1" v-bind:class="{ 'ml-3': hebrew, 'mr-3': !hebrew }">{{ hebrew ? 'רמת דיוק' : 'Precision' }}</div>
    <div class="mr-2 slider-wrap">
      <vue-slider v-model="value" :enable-cross="false" :dragOnClick="true" :minRange=3 :max=50 :tooltip="'active'"
        :height=9 :dotSize=20 @drag-end=getValue(value)>
      </vue-slider>
      <div class="d-flex justify-content-between mt-n2" dir="rtl">
        <small class="text-muted">{{ hebrew ? 'גבוהה' : 'High' }}</small>
        <small class="text-muted">{{ hebrew ? 'נמוכה' : 'Low' }}</small>
      </div>
    </div>
  </div>
</template>             

<script>
import { Actions } from '@/store/stateChanges'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'SetAccuracy',
  components: { VueSlider },
  data() {
    return {
      value: [this.$store.state.minRange, this.$store.state.maxRange > 50 ? 50 : this.$store.state.maxRange],
    };
  },
  computed: {
    hebrew() {
      return this.$settings.hebrew
    }
  },
  methods: {
    getValue(value) {
      this.$store.commit('SET_MIN_RANGE', value[0])
      let maxValue = value[1]
      if (maxValue == 50)
        maxValue = 10000
      this.$store.commit('SET_MAX_RANGE', maxValue)
      this.$store.dispatch(Actions.RUN_PARSE)
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.vue-slider-dot-tooltip-top {
  top: -5px;

  .vue-slider-dot-tooltip-inner {
    padding: 0;
    border-radius: 2px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.19);
    border: solid 1px #cfcfcf;
    background-color: #fafafa;
    color: #000;

    &::after {
      display: none;
    }
  }
}

.vue-slider-rail {
  background: white;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
}

.vue-slider-process {
  background-color: var(--primary);
}

.vue-slider-dot-handle {
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, .25);
}

.slider-wrap {
  width: 248px;
}
</style>
